<template>
  <div v-if="isSuperAdmin">
    <div class="row">
      <div class="col-xl-12 mb-md">
        <label style="float:left;margin-right:10px;">
          <input name="query" v-bind:value="keywords" v-on:input="debounceSearch($event.target.value)" class="form-control" placeholder="recherche" aria-controls="listing-datatable">
        </label>
        <label style="float:left;margin-right:10px;">
          <select v-model="agency_status" v-on:change="newStart('agency_status')" class="form-control" style='max-width:150px'>
            <option disabled value="">Statut</option>
            <option value="">Tous</option>
            <option v-for="option in agency_status_options" v-bind:value="option.agency_status_id">
              {{ option.agency_status }}
            </option>
          </select>
        </label>
        <label style="float:left;margin-right:10px;">
          <select v-model="rliss" v-on:change="newStart('rliss')" class="form-control" style='max-width:150px'>
            <option disabled value="">Sous-région</option>
            <option value="">Tous</option>
            <option v-for="option in rliss_options" v-bind:value="option.rliss_id">
              {{ option.rliss }}
            </option>
          </select>
        </label>
      </div>
    </div>
    <div class="table-responsive">
      <Grid
      :data="agencies"
      :columns="gridColumns"
      :columnsName="gridColumnsName"
      :sortColumns="gridColumnsSort"
      :loadData="refresh">
      </Grid>
    </div>
    <div class="row" style="margin-top: 25px;">
      <div class="col-sm-12">
        <button class="btn btn-primary" v-on:click="importation">Importer</button>
      </div>
    </div>
  </div>
</template>
<script>

import axios from 'axios';
import Grid from '@/components/Grid.vue';
import {privileges} from '@/mixins/privileges.js';

//import vueMultiSelect from 'vue-multi-select';
//import 'vue-multi-select/dist/lib/vue-multi-select.css';

export default {
  data: function() {return {
    keywords:'',
    entity: '5',
    rliss: '',
    agency_status:'',
    entity_options:{},
    rliss_options:{},
    agency_status_options:{},
    gridColumnsName: ['Fournisseur','Région','Sous-région','Status'],
    gridColumns: ['agency','entity','rliss','agency_status'],
    gridColumnsSort : ['agency','entity','rliss','agency_status'],
    sort: 'agency',
    agencies:{},
    selected_agencies:[],
  }},
  mixins: [privileges],
  name: 'Administration',

  components: {
    Grid,
  },

  methods: {

    debounceSearch: function(val){
      this.keywords = val;
      if(this.search_timeout) clearTimeout(this.search_timeout);
      const self = this;
      this.search_timeout = setTimeout(function() {

        self.startRow = 0;
      self.loadUsers();
      }, 200);
    },

    newStart:  function (field) {

      if(field=='entity')
      {
        this.rliss="";
        this.agency="";
      }
      else if(field=='rliss')
      {
        this.agency="";
      }

      this.startRow = 0;
      this.fromRow = 1;
      this.refresh();
      this.loadFilters();
    },

    loadFilters: function () {

      axios
        .get(this.$root.$data.server_base + '/api/administration_service_provider_dropdown.php',
          { params: {entity: this.entity}})
        .then(response => (this.agency_status_options = response.data.agency_status, this.rliss_options = response.data.rliss))

    },

    refresh: function() {

      axios
        .get(this.$root.$data.server_base + '/api/administration_service_provider.php',
          { params: {entity: this.entity,rliss: this.rliss,agency_status:this.agency_status,keywords:this.keywords,sort:this.sort, sortOrder: 1}})
        .then(response => (this.agencies = response.data.agencies))
    },

    importation: function() {

      axios
        .get(this.$root.$data.server_base + '/api/administration_service_provider_import.php',
          { params: {selected_agencies: this.selected_agencies}})
        .then(response => (this.refresh()))
    },

  },
  mounted () {
    this.refresh();
    this.loadFilters();
  },
}
</script>
